import { connect } from 'react-redux';

import * as actions from '../../actions';
import { Logout } from '@imprivata/nucleus';

const mapDispatchToProps = (dispatch) => {
  return {
    onLogoutClick: () => {
      dispatch(actions.logout() );
    },
  };
};

export default connect(null, mapDispatchToProps)(Logout);
